(()=>{
 'use strict';
 function initialize(){
  const page=document.querySelector('[data-koll-product]');
  if(!page)return;
  const wrappers=[...page.querySelectorAll('details[data-pdp-disclosure]')];
  let pendingHash='',hashObserver=null,frame=0;
  const ignored=new Set(['SCRIPT','STYLE','TEMPLATE','NOSCRIPT','LINK']);
  function hasContent(node){
   if(node.nodeType===3)return Boolean(node.textContent.trim());
   if(node.nodeType!==1||ignored.has(node.tagName)||node.hidden)return false;
   if(node.matches('img,video,audio,iframe,input,select,textarea,button,canvas,svg,table'))return true;
   return [...node.childNodes].some(hasContent);
  }
  function syncWrapper(wrapper){
   const content=[...wrapper.children].find(node=>node.matches('[data-disclosure-content]'));
   if(!content)return;
   const selector=wrapper.dataset.disclosureWatch;
   let present=false;
   if(selector){
    try{present=[...content.querySelectorAll(selector)].some(node=>!node.hidden);}catch{present=hasContent(content);}
   }else present=hasContent(content);
   if(wrapper.hidden===present)wrapper.hidden=!present;
   if(!present&&wrapper.open&&!wrapper.hasAttribute('data-disclosure-preserve-open'))wrapper.open=false;
  }
  function stopHashObserver(){
   hashObserver?.disconnect();
   hashObserver=null;
  }
  function hashTarget(hash){
   if(!hash||hash==='#')return null;
   let id;
   try{id=decodeURIComponent(hash.slice(1));}catch{return null;}
   const target=document.getElementById(id);
   return target&&page.contains(target)?target:null;
  }
  function reveal(target){
   const ancestors=[];
   for(let node=target;node&&page.contains(node);node=node.parentElement){
    if(node.matches('details[data-pdp-disclosure]'))syncWrapper(node);
    if(node.hidden)return false;
    if(node.tagName==='DETAILS')ancestors.push(node);
   }
   for(const details of ancestors.reverse())details.open=true;
   return true;
  }
  function focusTarget(target){
   const added=!target.hasAttribute('tabindex')&&!target.matches('a[href],button,input,select,textarea,summary');
   if(added)target.setAttribute('tabindex','-1');
   target.focus({preventScroll:true});
   if(added)target.addEventListener('blur',()=>target.removeAttribute('tabindex'),{once:true});
  }
  function tryHash({keyboard=false,smooth=false}={}){
   if(!pendingHash)return false;
   const target=hashTarget(pendingHash);
   if(!target||!reveal(target))return false;
   const expectedHash=pendingHash;
   pendingHash='';
   stopHashObserver();
   cancelAnimationFrame(frame);
   frame=requestAnimationFrame(()=>{
    if(location.hash!==expectedHash||!target.isConnected)return;
    const disclosure=target.closest('details[data-pdp-disclosure]');
    const destination=target.getClientRects().length?target:disclosure?.querySelector('summary')||target;
    if(keyboard)focusTarget(destination);
    destination.scrollIntoView({block:'start',behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'auto'});
   });
   return true;
  }
  function followHash(hash,options){
   pendingHash=hash;
   stopHashObserver();
   if(!pendingHash||tryHash(options))return;
   hashObserver=new MutationObserver(()=>tryHash(options));
   hashObserver.observe(page,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
  }
  for(const wrapper of wrappers){
   const content=[...wrapper.children].find(node=>node.matches('[data-disclosure-content]'));
   if(!content)continue;
   let scheduled=false;
   const observer=new MutationObserver(()=>{
    if(scheduled)return;
    scheduled=true;
    queueMicrotask(()=>{scheduled=false;syncWrapper(wrapper);});
   });
   observer.observe(content,{childList:true,subtree:true,attributes:true,attributeFilter:['hidden']});
   wrapper.addEventListener('toggle',()=>{
    if(!wrapper.open)for(const video of wrapper.querySelectorAll('video'))video.pause();
   });
   syncWrapper(wrapper);
  }
  document.addEventListener('click',event=>{
   if(event.defaultPrevented||event.button!==0||event.metaKey||event.ctrlKey||event.shiftKey||event.altKey)return;
   const link=event.target.closest('a[href]');
   if(!link||link.hasAttribute('download')||link.target&&link.target!=='_self')return;
   let url;
   try{url=new URL(link.href,location.href);}catch{return;}
   if(url.origin!==location.origin||url.pathname!==location.pathname||url.search!==location.search||!url.hash)return;
   const target=hashTarget(url.hash);
   if(!target||!reveal(target))return;
   event.preventDefault();
   if(location.hash!==url.hash)history.pushState(null,'',url.pathname+url.search+url.hash);
   followHash(url.hash,{keyboard:event.detail===0,smooth:true});
  });
  window.addEventListener('hashchange',()=>followHash(location.hash));
  window.addEventListener('popstate',()=>followHash(location.hash));
  window.addEventListener('pageshow',event=>{if(event.persisted){for(const wrapper of wrappers)syncWrapper(wrapper);followHash(location.hash);}});
  followHash(location.hash);
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initialize,{once:true});else initialize();
})();
